export default __webpack_public_path__ + "static/media/blue-share-icon.da1c02c8.svg";